// extracted by mini-css-extract-plugin
export default {"tariff":"LVQLi","image":"EL7Ty","information":"RJvpV","price":"wN23k","advantages":"_c5vG","textWrapper":"zjtQ7","wrapper":"qTk0l"};